/* eslint-disable no-param-reassign */

export default {
    install(Vue, options) {
        // console.log(options);

        Vue.yourMethod = (value) => value;

        Vue.mixin({
            created() {},
        });

        Vue.prototype.$myProperty = 'This is a Vue instance property.';
    },
};
